/* Kanadeal — encadre "points gagnes" sur les fiches produit. Lit le prix DOM, suit les variantes. */
(function(){
  if(window.__kdProductPointsInit) return;
  window.__kdProductPointsInit=true;
  var RATE=1, PT_VALUE=0.05;
  function parsePrice(el){
    if(!el) return 0;
    var t=(el.textContent||'').replace(/[^0-9.,]/g,'');
    if(t.indexOf(',')>-1 && t.indexOf('.')>-1){ t=t.replace(/\./g,'').replace(',','.'); }
    else if(t.indexOf(',')>-1){ t=t.replace(',','.'); }
    var v=parseFloat(t); return isFinite(v)?v:0;
  }
  function findPriceEl(scope){
    return scope.querySelector('.price-item--sale')||scope.querySelector('.price .price-item')||scope.querySelector('.price-item')||scope.querySelector('.price');
  }
  function fr(n){ try{return n.toLocaleString('fr-FR');}catch(e){return ''+n;} }
  function build(pts,euros){
    var e=(Math.round(euros*100)/100).toFixed(2).replace('.',',');
    return '<div class="kdpp__row">'+
        '<span class="kdpp__coin">🪙</span>'+
        '<div class="kdpp__txt"><span><b class="kdpp__pts">+'+fr(pts)+' point'+(pts>1?'s':'')+'</b> avec cet achat</span>'+
        '<span class="kdpp__sub">soit ≈ '+e+' € en récompenses · Club Kanadeal</span></div>'+
        '<a class="kdpp__info" href="/pages/mes-points" title="En savoir plus sur les points">?</a>'+
      '</div>';
  }
  function render(){
    var main=document.querySelector('main[data-template="product"]');
    if(!main) return;
    var euros=parsePrice(findPriceEl(main));
    if(!euros) return;
    var pts=Math.max(0,Math.floor(euros*RATE));
    var anchor=main.querySelector('.buy-buttons-block')||main.querySelector('.product-form-buttons')||main.querySelector('.shopify-product-form');
    if(!anchor||!anchor.parentNode) return;
    var box=main.querySelector('.kdpp');
    if(!box){ box=document.createElement('div'); box.className='kdpp'; anchor.parentNode.insertBefore(box,anchor); }
    box.innerHTML=build(pts,pts*PT_VALUE);
  }
  function watch(){
    var main=document.querySelector('main[data-template="product"]'); if(!main) return;
    var pe=findPriceEl(main); if(!pe) return;
    try{ new MutationObserver(function(){render();}).observe(pe,{childList:true,subtree:true,characterData:true}); }catch(e){}
  }
  function init(){ render(); watch(); [400,1000,2000].forEach(function(d){setTimeout(render,d);}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
